import { render, staticRenderFns } from "./setoransimpanan.vue?vue&type=template&id=0231047e&scoped=true&"
import script from "./setoransimpanan.vue?vue&type=script&lang=js&"
export * from "./setoransimpanan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0231047e",
  null
  
)

export default component.exports